import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form','smokingNumber'];
  static classes = ['errorm','hide'];
  static values = {validateurl: String};

  formTargetConnected() {
    this.toggleSmokingNumberInput();
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.parentElement.querySelector("."+this.errormClass);
      }
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const formData = new FormData(this.formTarget);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(Object.keys(response).length > 0){
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
              }
            })
          });
        }else{
          this.formTarget.submit();
        }
      }
    });
  }

  checkboxDisable(event){
    const el = event.currentTarget;
    const selectors = document.getElementsByName(el.name);
    if(el.checked == true){
      selectors.forEach(function(s){
        s.disabled = true;
      });
      el.disabled = false;
    }else{
      selectors.forEach(function(s){
        s.disabled = false;
      });
    }
  }

  toggleSmokingNumberInput(){
    const form = this.formTarget;
    const smoking = form.querySelector("input[name='user_health_info[smoking]']:checked");
    if(smoking != undefined){
      if(smoking.value == "not"){
        this.smokingNumberTarget.classList.add(this.hideClass);
      }else{
        this.smokingNumberTarget.classList.remove(this.hideClass);
      }
    }
  }

}
